<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0 && mostrarDespesa"
            ></app-erros-box>
            <despesa v-if="mostrarDespesa"
                :despesa="despesa"
                :temAcessoDetalharItem="$temAcessoView('DESP-GERAIS-REQ-00')"
                :temAcessoHistorico="$temAcessoView('DESP-GERAIS-REQ-00')"
                :temAcessoInserirItem="$temAcessoView('DESP-GERAIS-REQ-02')"
                :temAcessoAtualizarItem="$temAcessoView('DESP-GERAIS-REQ-02')"
                :temAcessoAtualizarDespesa="$temAcessoView('DESP-GERAIS-REQ-02')"
                :temAcessoAnexos="$temAcessoView('DESP-GERAIS-REQ-00')"
                :rotaDetalharItem="'DespesasGerais_Requisitantes_ItensDespesa_Detalhar'"
                :rotaAtualizarDespesa="'DespesasGerais_Requisitantes_Despesas_Atualizar'"
                :rotaAtualizacaoEmMassa="'DespesasGerais_Requisitantes_Despesas_AtualizarRateiosEmMassa'"
                @inserirItem="abrirModalFormItem('INSERIR', null)"
                @atualizarItem="abrirModalFormItem('ATUALIZAR', $event)"
                @excluirItem="confirmarExcluirItem($event)"
                :mostrarAnexos="mostrarAnexos"
                :anexos="anexos"
                @mostrarAnexos="obterAnexos()"
                @fecharAnexos="fecharAnexos()"
                @inserirAnexo="abrirModalFormAnexo('INSERIR', null)"
                @atualizarAnexo="abrirModalFormAnexo('ATUALIZAR', $event)"
                @excluirAnexo="excluirAnexo($event)"
                @baixarAnexo="baixarAnexo($event)"
                :servicos="obterServico()"
                @obterDespesa="obterDespesa()"
                @obterAtualizacao="obterDespesa()"
                :anexoServicos="obterAnexoServico()"
                @obterUnidades="obterUnidades()"
                @obterAcoes="obterAcoes($event)"
                @obterProjetos="obterProjetos($event)"
                :unidades="unidades"
                :projetos="projetos"
                :acoes="acoes"
                @salvarRateios="salvarRateiosEmMassa($event)"
            >
                <template slot="footer">
                    <app-btn-voltar></app-btn-voltar>
                    <btn-comprometer
                        :despesa="despesa"
                        @obterDespesa="obterDespesa()"
                        @exibirErro="exibirErroSaldo($event)"
                    ></btn-comprometer>
                    <btn-solicitar-aprovacao
                        :despesa="despesa"
                        @obterDespesa="obterDespesa()"
                    ></btn-solicitar-aprovacao>
                </template>
            </despesa>
        </div>
        <div>
            <inserir-atualizar-item-despesa-form
                :mostrarModal="mostrarModalItem"
                :acao="acaoItem"
                :despesa="despesa"
                :itemAtualizarId="itemAtualizarId"
                @fechar="fecharModalFormItem()"
                @atualizar="obterDespesa()"
            >
            </inserir-atualizar-item-despesa-form>
            <inserir-atualizar-anexo-form
                :mostrarModal="mostrarModalAnexo"
                :acao="acaoAnexo"
                :despesa="despesa"
                :anexoAtualizarId="anexoAtualizarId"
                @fechar="fecharModalFormAnexo()"
                @atualizar="obterAnexos()"
            >
            </inserir-atualizar-anexo-form>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import Despesa from '@/app/despesasgerais/componentes/despesas/Despesa.vue';
import DespesasServicos from './DespesasServicos'
import ItensDespesasServicos from '../itensDespesas/ItensDespesasServicos';
import InserirAtualizarItemDespesaForm from '../itensDespesas/InserirAtualizarItemDespesaForm.vue';
import InserirAtualizarAnexoForm from './InserirAtualizarAnexoForm.vue';
import DespesasAnexosServicos from './DespesasAnexosServicos'
import BtnComprometer from './BtnComprometer.vue';
import BtnSolicitarAprovacao from './BtnSolicitarAprovacao.vue';
import RateiosServicos from '../rateios/RateiosServicos';

export default {
    data() {
        return {
            despesa: null,
            mostrarModalItem: false,
            acaoItem: null,
            itemAtualizarId: null,
            mostrarAnexos: false,
            anexos: [],
            mostrarModalAnexo: false,
            acaoAnexo: null,
            anexoAtualizarId: null,
            erros: [],
            unidades: [],
            projetos: [],
            acoes: []
        }
    },

    components: {
        Despesa,
        InserirAtualizarItemDespesaForm,
        InserirAtualizarAnexoForm,
        BtnComprometer,
        BtnSolicitarAprovacao
    },

    methods: {
        obterDespesa() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterPorId(this.$route.params.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.despesa = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrirModalFormItem(acao, item) {
            this.acaoItem = acao
            this.itemAtualizarId = acao == 'ATUALIZAR' ? item.despesaItemId : null
            this.mostrarModalItem = true
        },

        fecharModalFormItem() {
            this.mostrarModalItem = false
        },
        
        confirmarExcluirItem(item) {
            this.$swal({
                title: 'Item',
                html: `Confirma a exclusão do item<br/><b>${item.nomeProduto}<br/>${item.nomeNatureza}<br/>${item.nomeUnidade}</b>?
                    <br/><br/><b>O rateio deste item também será excluído!</b>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirItem(item)
                }
            })
        },

        excluirItem(item) {
            this.$store.dispatch('addRequest')
            ItensDespesasServicos.excluirItemDespesa(item.despesaItemId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Item excluido com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterDespesa()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAnexos() {
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.obterAnexos(this.$route.params.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.anexos = response.data
                        this.mostrarAnexos = true
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        
        excluirAnexo(anexo) {
            this.$store.dispatch('addRequest')
            DespesasAnexosServicos.excluirAnexo(anexo).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Anexo excluido',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterAnexos()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        baixarAnexo(anexo) {
            DespesasAnexosServicos.baixarAnexo(anexo).then(response => {
                if (response) {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao realizar download do anexo!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                anexo.nomeArquivoOriginal
                            )
                        }
                    }
                }
            })
        },  

        fecharAnexos() {
            this.mostrarAnexos = false
        },

        abrirModalFormAnexo(acao, anexo) {
            this.acaoAnexo = acao
            this.anexoAtualizarId = acao == 'ATUALIZAR' ? anexo.despesaAnexoId : null
            this.mostrarModalAnexo = true
        },
        
        fecharModalFormAnexo() {
            this.mostrarModalAnexo = false
        },

        exibirErroSaldo(erroSaldo) {
            this.erros = erroSaldo.split(';')
        },

        obterServico() {
            return DespesasServicos
        },

        obterAnexoServico() {
            return DespesasAnexosServicos
        },

        obterUnidades() {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterUnidades().then(response => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProjetos(evento) {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterProjetos(evento.codUnidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAcoes(evento){
            this.$store.dispatch('addRequest')
            RateiosServicos.obterAcoes(evento.codUnidade, evento.codProjeto).then(response => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvarRateiosEmMassa(rateiosDto) {
            this.$store.dispatch('addRequest')
            RateiosServicos.salvarRateiosEmMassa(rateiosDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Rateios atualizados com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterDespesa()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterDespesa()
    },

    watch: {
        $route(to) {
            if (this.$store.getters.recarregar) {
                this.obterDespesa()
                this.$store.dispatch('setRecarregar', false)
            }
        }  
    },

    computed: {
        mostrarDespesa() {
            return this.$route.name === 'DespesasGerais_Requisitantes_Despesas_Detalhar'
        }
    },
}
</script>